export const SET_ACTIONS_LOGS = 'SET_ACTIONS_LOGS'
export const RESET_ACTIONS_LOGS = 'RESET_ACTIONS_LOGS'
